import React from 'react';
import { apiAddCurrentFactory } from 'api';

const useAddFactoryToSupplier = (supplierId) => {
  const [loading, setLoading] = React.useState(false);

  const addFactory = async (factoryIds) => {
    try {
      setLoading(true);
      const response = await apiAddCurrentFactory(supplierId, factoryIds);
      return response;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return { loading, addFactory };
};

export default useAddFactoryToSupplier;
